import React from 'react';
import CookieScript from './CookieScript';
import PendoScript from './PendoScript';
import FacebookScript from './FacebookScript';
import ConvertExperimentsScript from './ConvertExperimentsScript';
import NewRelicScript from './NewRelicScript';
import AdobeAnalyticsScript from './AdobeAnalyticsScript';
import type { AdobeAnalyticsUser } from '../../../lib/util/adobeAnalytics';

type Props = {
  pathname?: string | null;
  asPath?: string;
  user?: AdobeAnalyticsUser | null;
  showCookieBanner?: boolean;
};

/**
 * Scripts.
 */
const Scripts = ({
  pathname = '',
  asPath = '',
  user,
  showCookieBanner = true,
}: Props) => {
  return (
    <>
      <NewRelicScript />
      <FacebookScript />
      <PendoScript />
      <ConvertExperimentsScript asPath={asPath} />
      {showCookieBanner && <CookieScript />}
      <AdobeAnalyticsScript asPath={asPath} pathname={pathname} user={user} />
    </>
  );
};

export default Scripts;
